export default __webpack_public_path__ + "static/media/steel-pipes-put-together.b56e4db8.webp";